interface StampFlashProps {
  show: boolean;
  quantity: number;
  currencyLabel?: string;      // per-shop points word (040); default BEANS
  accentColor?: string | null; // shop's storefront tint (040); null = cyan
}

// The every-stamp reveal — WelcomeFlash's little sibling. WELCOME is reserved
// for the genuine first stamp ever (see first-visit.ts isFirstStampEver);
// every later confirmed stamp gets this beat instead. Same .level-up-flash
// overlay/animation so the family of flashes feels consistent.
export default function StampFlash({ show, quantity, currencyLabel, accentColor }: StampFlashProps) {
  if (!show) return null;

  return (
    <div className="level-up-flash">
      <div
        className="rounded-[16px] p-8 text-center"
        style={{
          background: 'linear-gradient(180deg,#f96a55,#ffcc00 45%,#36d9d3)',
          boxShadow: accentColor ? `0 0 0 3px ${accentColor}` : undefined,
        }}
      >
        <p className="font-heading text-lg text-white">
          {quantity > 1 ? `${quantity}x STAMP GET!` : 'STAMP GET!'}
        </p>
        <p className="font-grotesk font-bold text-3xl text-white mt-2">
          +{quantity * 10} {currencyLabel || 'BEANS'}
        </p>
      </div>
    </div>
  );
}
